'use client';

import React from 'react';

interface NotesFieldProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
}

export default function NotesField({ value, onChange, maxLength = 500 }: NotesFieldProps) {
  return (
    <div className="relative">
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
        rows={2}
        placeholder="Tell our editors anything special about this property..."
        className="w-full resize-none rounded-xl bg-white/[0.02] border border-white/[0.08] px-4 py-3 text-sm text-gray-200 placeholder:text-gray-600 focus:outline-none focus:border-purple-500/50 focus:ring-2 focus:ring-purple-500/20 transition-colors"
      />
      <span className="absolute bottom-2 right-3 text-[11px] text-gray-600">
        {value.length}/{maxLength}
      </span>
    </div>
  );
}
